/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-cycle */
import React, { useState, useEffect, useRef } from 'react';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Page,
  Selection, Toolbar, Edit, Sort, Filter, ColumnChooser, Resize,
  PdfExport,
  ExcelExport,
} from '@syncfusion/ej2-react-grids';
import { ToolbarComponent, ItemsDirective, ItemDirective } from '@syncfusion/ej2-react-navigations';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import axios from 'axios';
import { useStateContext } from '../contexts/ContextProvider';
import Header from './Header';
import { eventsGrid, eventsCPGrid, eventsCPXGrid, eventsLayoutGrid } from '../data/dummy';
import '../pages/Zackat.css';

function Events({ props }) {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=associatescontrolcenter');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const {
    zRenderMode,
    limitPreference,
    setLimitPreference,
    boss,
  } = useStateContext();

  const [pauseEnable, setPause] = useState(false);
  const grid = useRef(null);
  const pause = { text: 'Pause', tooltipText: 'Pause Refresh', prefixIcon: 'e-pause', id: 'pause', disabled: pauseEnable };
  const resume = { text: 'Resume', tooltipText: 'Resume Refresh', prefixIcon: 'e-repeat', id: 'resume', disabled: !pauseEnable };
  const excel = { text: 'Excel Export', tooltipText: 'Export', prefixIcon: 'e-export-excel', id: 'excel', disabled: false };
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [fromHere, setFromHere] = useState(new Date());
  const [toHere, setToHere] = useState(new Date());
  const [reload, setReload] = useState(false);
  let myhipaa = true;
  if (props && props.hipaa && props.hipaa.consent) {
    myhipaa = props.hipaa.consent;
  }
  const [hipaa] = useState(myhipaa);
  let toolbarOptions = ['Search', pause, resume];
  const calculateDays = (f, t) => {
    if (!f || !t) return null;

    const start = new Date(f);
    const end = new Date(t);

    // Get time difference in milliseconds
    const timeDiff = end.getTime() - start.getTime();

    // Convert milliseconds to days and round the value
    const dayInMs = 24 * 60 * 60 * 1000;
    const daysDiff = Math.ceil(timeDiff / dayInMs);

    return daysDiff;
  };

  const fromTemplate = () => (
    <div className="flex">
      <span className="e-icons e-timeline-month" />
      <DateTimePickerComponent
        id="fromdate"
        onChange={(e) => {
          setFrom((e.value.getTime() / 1000).toFixed(0));
          setFromHere(e.value);
        }}
        placeholder="Select From Date/Time"
        defaultValue={fromHere}
      />
    </div>
  );
  const toTemplate = () => (
    <div className="flex">
      <span className="e-icons e-timeline-month" />
      <DateTimePickerComponent
        id="todate"
        onChange={(e) => {
          setTo((e.value.getTime() / 1000).toFixed(0));
          setToHere(e.value);
          const days = calculateDays(fromHere, e.value);
          if ((days !== null && days > 0) || e.value !== toHere) {
            setReload(days);
          }
        }}
        placeholder="Select To Date/Time"
        defaultValue={toHere}
      />
    </div>
  );

  const [searchParams] = useSearchParams();
  let associateid = searchParams.get('id');
  let assocId = searchParams.get('name');
  let associatename = 'Events for ';
  let device = searchParams.get('device');
  let myfont = '';
  let source = '';
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [eventLimit, setEventLimit] = useState(localStorage.getItem('eventLimit') || 14);
  const setLimits = () => {
    const lim = document.getElementById('limit').value;
    setData([]);
    setEventLimit(lim);
    setFrom(0);
    setTo(0);
    setFromHere(new Date());
    setToHere(new Date());
    localStorage.setItem('eventLimit', Number(lim));
    setLimitPreference(!limitPreference);
  };

  const limitTemplate = () => (
    <div className="e-toolbar-left">
      <input type="text" id="limit" placeholder="Limit number of days" defaultValue={eventLimit} className="custom-toolbar-input" />
      <button type="button" className="e-btn e-success e-outline" onClick={() => { setLimits(); }}>Limit Days</button>
    </div>
  );

  const onDataBound = () => {
    // Select the search input by class name
    const searchInput = document.querySelector('#gridcomp .e-input-group .e-input');
    if (grid && grid.current && searchInput && !searchInput.dataset.listenerAttached) {
      // Prevent multiple listeners if dataBound fires again
      searchInput.dataset.listenerAttached = 'true';
      searchInput.addEventListener('keyup', (args) => {
        grid.current.search(args.target.value);
      });

      searchInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          // Trap the enter key if needed
          grid.current.search(e.target.value);
          e.preventDefault();
          e.stopPropagation();
        }
      });
    }
  };
  if (props && props._id && props._id.length > 0 && props.name && props.name.length > 0) {
    associateid = props._id;
    assocId = props.name;
    device = props.device;
    associatename += props.name;
    source = props.source;
    myfont = 'e-mygrid';
  } else if (props && props._id && props._id.length > 0 && props.device.length > 0) {
    associateid = ''; // props.associateid;
    assocId = props.device;
    device = props.device;
    associatename += props.device;
    source = props.source;
    myfont = 'e-mygrid';
  } else if (associateid) {
    associatename += `${assocId}`;
  } else {
    associatename += `${device}`;
    associateid = null;
  }
  let biostr = ' | ';
  if (source === 'controlpanel') {
    biostr = '<br />';
    toolbarOptions = [pause, resume, excel, 'Search'];
  }

  const editing = { allowDeleting: false, allowEditing: false };
  const { REACT_APP_API_ENDPOINT } = process.env;
  const timerid = useRef();
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (device !== null) {
        const query = Object.entries(usr)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        let url = `${REACT_APP_API_ENDPOINT}/events?${query}&associateid=${associateid}&device=${device}&limit=${eventLimit}&source=${source}`;
        if (!associateid || associateid.length === 0) {
          url = `${REACT_APP_API_ENDPOINT}/events?${query}&device=${device}&limit=${eventLimit}&source=${source}`;
        }
        if (from !== 0 && to !== 0) {
          url = `${REACT_APP_API_ENDPOINT}/events?${query}&device=${device}&from=${from}&to=${to}&source=${source}`;
        }
        await axios({
          url,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (response.data && response.data.length > 0) {
              response.data.map((event, index) => {
                if (event && event.biometrics && event.biometrics.length > 1) {
                  event.biometrics.forEach((bio, bioindex) => {
                    if (bioindex === 0) {
                      response.data[index].vitals.type = '';
                      response.data[index].vitals.reading = '';
                    }
                    response.data[index].vitals.type += `${event.biometrics[bioindex].type}${biostr}`;
                    response.data[index].vitals.reading += `${event.biometrics[bioindex].reading}${biostr}`;
                  });
                }
                return true;
              });
              setData(response.data);
            }
          })
          .catch((error) => {
            console.error(error.message);
          });
        setLoading(false);
      } else {
        let url = `${REACT_APP_API_ENDPOINT}/events?associateid=${associateid}&limit=${eventLimit}&source=${source}`;
        if (from !== 0 && to !== 0) {
          url = `${REACT_APP_API_ENDPOINT}/events?associateid=${associateid}&from=${from}&to=${to}&source=${source}`;
        }
        await axios({
          url,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        }).then((response) => {
          if (response.data && response.data.length > 0) {
            response.data.map((event, index) => {
              if (event && event.biometrics && event.biometrics.length > 1) {
                event.biometrics.forEach((bio, bioindex) => {
                  if (bioindex === 0) {
                    response.data[index].vitals.type = '';
                    response.data[index].vitals.reading = '';
                  }
                  response.data[index].vitals.type += `${event.biometrics[bioindex].type}${biostr}`;
                  response.data[index].vitals.reading += `${event.biometrics[bioindex].reading}${biostr}`;
                });
              }
              return true;
            });
            setData(response.data);
          }
        })
          .catch((error) => {
            console.error(error.message);
          });
        setLoading(false);
      }
    };
    fetchData();
  }, [associateid, eventLimit, reload]);

  useEffect(() => {
    if (!pauseEnable) {
      const timeout = 30000;
      timerid.current = setInterval(setReload(!reload), timeout);
    }
    return () => {
      timerid.current = clearInterval(timerid.current);
    };
  }, [props, pauseEnable]);
  const flattenObject = (obj, prefix = '') => Object.keys(obj).reduce((acc, k) => {
    const pre = prefix.length ? `${prefix}.` : '';
    if (
      typeof obj[k] === 'object'
      && obj[k] !== null
      && Object.keys(obj[k]).length > 0
    ) {
      Object.assign(acc, flattenObject(obj[k], pre + k));
    } else {
      acc[pre + k] = obj[k];
    }
    return acc;
  }, {});

  const clickHandler = (args) => {
    if (args.item.properties.text === 'Pause') {
      setPause(!pauseEnable);
    } else if (args.item.properties.text === 'Resume') {
      setPause(!pauseEnable);
    } else if (grid && grid.current && args.item.properties.text === 'PDF Export') {
      const properties = {
        fileName: `PDFExport_${associatename}_${new Date().toISOString()}.pdf`,
        pageOrientation: 'Landscape',
      };
      grid.current.pdfExport(flattenObject(properties));
    } else if (grid && grid.current && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `ExcelExport_${associatename}_${new Date().toISOString()}.xlsx`,
      };
      grid.current.excelExport(flattenObject(properties));
    }
  };
  if (loading) {
    return <p>Loading... </p>;
  }
  const wrapSettings = { wrapMode: 'Both' };
  const FilterOptions = {
    type: 'Menu',
  };
  return (
    <div
      className={source === 'controlpanel'
        ? 'm-1 md:m-1 mt-2 p-2 md:p-2 rounded-3xl'
        : source === 'layout'
          ? 'rounded-3xl'
          : 'm-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl zackat-div'}
    >
      {source !== 'layout'
      && (
      <div id="container">
        <Header category="" title={associatename} />
        <ToolbarComponent id="toolbar">
          <ItemsDirective>
            <ItemDirective template={limitTemplate} disabled={false} />
            <ItemDirective type="Separator" />
            {boss && <ItemDirective template={fromTemplate} disabled={false} />}
            {boss && <ItemDirective type="Separator" />}
            {boss && <ItemDirective template={toTemplate} disabled={false} />}
            {boss && <ItemDirective type="Separator" />}
          </ItemsDirective>
        </ToolbarComponent>
      </div>
      )}
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            <GridComponent
              id="gridcompevents"
              dataSource={data}
              dataBound={onDataBound}
              className={myfont}
              allowPaging
              width="100%"
              height={source === 'layout' ? '600px' : 'auto'}
              allowSorting
              allowExcelExport
              allowPdfExport
              editSettings={editing}
              toolbar={toolbarOptions}
              toolbarClick={clickHandler}
              enableHover={false}
              pageSettings={{ pageSize: 25, pageCount: 10 }}
              allowResizing
              allowFiltering
              filterSettings={FilterOptions}
              showColumnChooser
              textWrapSettings={wrapSettings}
              ref={grid}
              enableAdaptiveUI
              rowRenderingMode={zRenderMode}
              enableAltRow
              enablePersistence={source === 'layout'}
            >
              {source === 'controlpanel' && (
              <ColumnsDirective>
                {hipaa && (
                  eventsCPGrid.map((item, index) => <ColumnDirective key={index} {...item} />)
                )}
                {!hipaa && (
                  eventsCPXGrid.map((item, index) => <ColumnDirective key={index} {...item} />)
                )}
              </ColumnsDirective>
              )}
              {source === 'layout' && (
              <ColumnsDirective>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                {eventsLayoutGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
              </ColumnsDirective>
              )}
              {source === '' && (
              <ColumnsDirective>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                {eventsGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
              </ColumnsDirective>
              )}
              <Inject services={[Search, Page, Selection, Toolbar, Edit, Sort, Filter, ColumnChooser, Resize, PdfExport, ExcelExport]} />

            </GridComponent>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Events;
